import * as actions from "../Constants/actionTypes";
import { AlertError } from "Utils/alertUtils";
import { paginations_25_items } from "Utils/globalUtils"

const initState = {
    isLoading: false,
    data: {
        totals: 1,
        page_size: paginations_25_items,
        current_page: 1,
        next_page: null,
        previous_page: null,
        pages: 1,
        results: []
    },
};

const myReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.AT_GET_ALL_STUDENTS_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case actions.AT_GET_ALL_STUDENTS_SUCCESS: {
            const { totals, page_size } = action.payload;
            return {
                ...state,
                isLoading: false,
                data: {
                    ...action.payload,
                    pages: Math.ceil(totals / paginations_25_items)
                }
            };
        }
        case actions.AT_GET_ALL_STUDENTS_FAILURE: {
            const { error } = action.payload;
            AlertError(error);
            return {
                ...state,
                isLoading: false,
                data: initState.data
            };
        }
        default:
            return state;
    }
};

export default myReducer;
